var _style, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.35;fill:#10B981;}\n\t.st1{fill:#EF5939;}\n\t.st2{fill:#F3F0D2;}\n\t.st3{fill:#3A6882;}\n\t.st4{fill:#2E364F;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.3,24.5c4.2,10.6,3.2,25.2-4,30.3c-7.2,5-20.7,0.5-30.1-7S5.6,29.9,8.2,21.6C10.7,13.2,21,7,30.9,7.1 C40.8,7.3,50.1,13.9,54.3,24.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.2,42.2c-0.4,0-0.8,0.4-0.8,0.8v10.3c0,0.4,0.4,0.8,0.8,0.8c0.1,0,0.2,0,0.3-0.1l3.2-1.6 c0.3-0.1,0.4-0.4,0.4-0.7v-3.9c0-0.2,0-0.3-0.1-0.4l-3.2-4.7C27.7,42.3,27.5,42.2,27.2,42.2L27.2,42.2z M36.7,42.2 c-0.3,0-0.5,0.1-0.6,0.4l-3.2,4.7c-0.1,0.1-0.1,0.3-0.1,0.4v3.9c0,0.3,0.2,0.6,0.4,0.7l3.2,1.6c0.4,0.2,0.9,0,1.1-0.4 c0.1-0.1,0.1-0.2,0.1-0.3V43C37.5,42.6,37.1,42.2,36.7,42.2C36.7,42.2,36.7,42.2,36.7,42.2L36.7,42.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M32,37.5c-3,0-5.5,2.5-5.5,5.5c0,3,2.5,5.5,5.5,5.5s5.5-2.5,5.5-5.5C37.5,40,35,37.5,32,37.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.6,22.4l4.7,1.6c1,0.3,1.5-1.2,0.5-1.5l-4.7-1.6C9.2,20.6,8.7,22,9.6,22.4z M53.8,20.9l-4.7,1.6 c-1,0.3-0.5,1.9,0.5,1.5l4.7-1.6C55.4,22,54.9,20.6,53.8,20.9L53.8,20.9z M14.4,26.4L9.6,28c-1,0.3-0.5,1.8,0.5,1.5l4.7-1.6 C16,27.5,15.7,26,14.4,26.4z M49.1,27.9l4.7,1.6c1,0.4,1.5-1.2,0.5-1.5l-4.7-1.6C48.6,26.1,48.1,27.5,49.1,27.9L49.1,27.9z  M22.2,9.9c-1.6,0-2.9,0.9-4,2c-1,1-1.8,2.1-2,3.5c-0.1,1.4,0.5,2.8,2,4.3l0.6,0.6l7.8-7.8L26,11.9l0,0C24.8,11,23.5,9.9,22.2,9.9z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M27.7,13.6l-7.8,7.8l4.6,4.6c0.3,0.3,0.8,0.3,1.1,0l6.9-6.7c0.3-0.3,0.3-0.8,0-1.1c0,0,0,0,0,0L27.7,13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M38.2,24.8l-6.9,7c-0.3,0.3-0.3,0.8,0,1.1l8,8c0.1,0.1,0.3,0.2,0.6,0.2h7c0.4,0,0.8-0.4,0.8-0.8c0,0,0,0,0,0 v-7.1c0-0.2-0.1-0.4-0.2-0.6l-8.2-7.9C38.9,24.4,38.5,24.5,38.2,24.8L38.2,24.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M44.6,29.9v1H43c-0.4,0-0.8,0.4-0.8,0.8c0,0,0,0,0,0v1.6h-1.6c-0.4,0-0.8,0.4-0.8,0.8v1.6l-1.6,0 c-0.4,0-0.8,0.4-0.8,0.8v1.4h-1.1l1.6,1.6h0.3c0.4,0,0.8-0.4,0.8-0.8c0,0,0,0,0,0v-1.5l1.6,0c0.4,0,0.8-0.4,0.8-0.8v-1.6H43 c0.4,0,0.8-0.4,0.8-0.8v-1.6h1.6c0.4,0,0.8-0.4,0.8-0.8c0,0,0,0,0,0v-0.3L44.6,29.9z M26.6,12.5l-7.8,7.8l1.1,1.1l7.8-7.8 L26.6,12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.4,9.9c-1.4,0-3.1,1.3-4.4,2.6l7.9,7.8c1.3-1.3,2.5-3.1,2.5-4.9c0-1.2-1-2.5-2-3.5 C44.2,10.9,42.8,9.9,41.4,9.9L41.4,9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M35.9,13.6L16.4,32.7c-0.2,0.1-0.2,0.4-0.2,0.6v7.1c0,0.4,0.4,0.8,0.8,0.8c0,0,0,0,0,0h7.1 c0.2,0,0.4-0.1,0.6-0.2l19.2-19.5L35.9,13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M19.3,29.8l-1.6,1.5v0.3c0,0.4,0.4,0.8,0.8,0.8c0,0,0,0,0,0h1.6V34c0,0.4,0.4,0.8,0.8,0.8c0,0,0,0,0,0h1.6v1.6 c0,0.4,0.4,0.8,0.8,0.8c0,0,0,0,0,0h1.6v1.5c0,0.4,0.4,0.8,0.8,0.8c0,0,0,0,0,0H26l1.6-1.6h-1.1v-1.5c0-0.4-0.4-0.8-0.8-0.8h-1.6 V34c0-0.4-0.4-0.8-0.8-0.8c0,0,0,0,0,0h-1.6v-1.6c0-0.4-0.4-0.8-0.8-0.8h-1.6V29.8z M37,12.5l-1.1,1.1l7.9,7.8l1.1-1.1L37,12.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContest);
export default __webpack_public_path__ + "static/media/contest.933f9c7ad7f7076fb0749f63961a9e6b.svg";
export { ForwardRef as ReactComponent };